import { render } from "./MessageTimeBar.vue?vue&type=template&id=22c199b2&scoped=true"
import script from "./MessageTimeBar.vue?vue&type=script&lang=js"
export * from "./MessageTimeBar.vue?vue&type=script&lang=js"

import "./MessageTimeBar.vue?vue&type=style&index=0&id=22c199b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c199b2"]])

export default __exports__